import { mapLocaleToCulture, resolveLocale } from '../utils/locale.js';
import { apiUrl } from './config.js';

const JOB_INFO_ENDPOINT = apiUrl('/job/v1');

const normalizeViewCount = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const fetchJobById = async (jobId, locale) => {
  const culture = mapLocaleToCulture(locale);
  const headers = {
    Version: '1',
  };

  if (culture) {
    headers['X-Culture'] = culture;
  }

  const response = await fetch(`${JOB_INFO_ENDPOINT}/${jobId}/info`, {
    method: 'GET',
    headers,
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`Job fetch failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

const updateViewCountNodes = (container, viewCount) => {
  if (!container || viewCount === null) return;
  const targets = container.querySelectorAll('[data-view-count]');
  targets.forEach((target) => {
    target.textContent = String(viewCount);
  });
};

export const refreshJobViewCount = async ({ jobId, detailElement, cardElement }) => {
  if (!jobId) return null;

  try {
    const locale = resolveLocale();
    const payload = await fetchJobById(jobId, locale);
    const viewCount = normalizeViewCount(payload?.data?.job?.viewCount);
    if (viewCount === null) return null;

    updateViewCountNodes(detailElement, viewCount);
    updateViewCountNodes(cardElement, viewCount);
    return viewCount;
  } catch (error) {
    console.warn(`Failed to refresh view count for job ${jobId}:`, error);
    return null;
  }
};

export const initStandaloneJobDetailViewCount = () => {
  const detailPage = document.querySelector('div.job-detail-page[data-job-id]');
  if (!detailPage) return;
  if (detailPage.closest('section.job-detail-section')) return;

  const jobId = detailPage.getAttribute('data-job-id');
  if (!jobId) return;

  refreshJobViewCount({
    jobId,
    detailElement: detailPage,
  });
};
